var dummyStudentData = {
  student: {
    _id: '5d77739b5a78012f8acaa5a5',
    profile: {
      middleName: 'Mohamed',
      email: 'fake@mail.com',
      phone: '01234567890',
      firstName: 'Nour',
      lastName: 'Hosni',
      avatar: 'https://coligo-lms-prod.s3.amazonaws.com/assets/student-avatar.png'
    }
  },
  score: 100,
  maxScore: 100,
  progress: null,
  _id: '5d77739b5a78012f8acaa5a5',
  profile: {
    middleName: 'Mohamed',
    email: 'fake@mail.com',
    phone: '01234567890',
    firstName: 'Nour',
    lastName: 'Hosni',
    avatar: 'https://coligo-lms-prod.s3.amazonaws.com/assets/student-avatar.png'
  },
  percentage: 100
};
var dummyGradableItemStatus = {
  "new": {
    number: 3,
    percentage: 0.3
  },
  missed: {
    number: 2,
    percentage: 0.2
  },
  excused: {
    number: 1,
    percentage: 0.1
  },
  graded: {
    number: 4,
    percentage: 0.4
  }
};
export default {
  dummyStudentData: dummyStudentData,
  dummyGradableItemStatus: dummyGradableItemStatus
};